import React from 'react';

export const ShareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 2.66699V11.667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3327 6.00033L9.99935 2.66699L6.66602 6.00033"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 11V15.9C2.5 16.3243 2.69754 16.7313 3.04917 17.0314C3.40081 17.3314 3.87772 17.5 4.375 17.5H15.625C16.1223 17.5 16.5992 17.3314 16.9508 17.0314C17.3025 16.7313 17.5 16.3243 17.5 15.9V11"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
